import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "@environments/environment";
import {SettingsManagerService} from "../../../services/settings-manager.service";

@Component({
  selector: 'app-training-page-access-code',
  templateUrl: './training-page-access-code.component.html',
  styleUrls: ['./training-page-access-code.component.scss']
})
export class TrainingPageAccessCodeComponent implements OnInit {

  name: string;
  surname: string;
  accessCode: string;
  error: boolean;

  constructor(
    public settingsManagerService: SettingsManagerService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.name = localStorage.getItem('name');
    this.surname = localStorage.getItem('surname');
    this.route.queryParamMap.subscribe(paramMap => {
      this.error = paramMap.has('error') && paramMap.get('error') == 'true';
    });
  }

  async access() {
    localStorage.setItem('access-code', this.accessCode);
    localStorage.setItem('name', this.name);
    localStorage.setItem('surname', this.surname);
    await this.router.navigate(['..'], {relativeTo: this.route});
    this.accessCode = '';
  }

  valid() {
    return this.name && this.name.length > 0 && this.surname && this.surname.length > 0 && this.accessCode && this.accessCode.length > 0
  }

  get environment() { return environment }

}
